"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var createUseStorageState_1 = require("../createUseStorageState");

var useLocalStorageState = createUseStorageState_1.createUseStorageState(typeof window === 'object' ? window.localStorage : null);
exports["default"] = useLocalStorageState;